import { Component } from '@angular/core';
import { SidebarComponent } from '../shared/common-components/sidebar/sidebar.component';
import { HeaderComponent } from '../shared/common-components/header/header.component';

@Component({
  selector: 'app-ngo-layout',
  standalone: true,
  imports: [SidebarComponent, HeaderComponent],
  template: `
    <div class="layout-root">
      <app-sidebar class="sidebar"></app-sidebar>
      <div class="main-content bg-[#fafafb]">
        <app-header class="fixed-header"></app-header>
        <div class="content-area">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
  styles: `
    .layout-root {
      display: flex;
      height: 100vh;
    }

    .sidebar {
      width: 240px;
      height: 100vh;
      flex-shrink: 0;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 1100;
    }

    .main-content {
      margin-left: 260px; /* 240px sidebar + 20px gap */
      display: flex;
      flex-direction: column;
      width: calc(100% - 260px); /* Updated to match the sidebar width + gap */
      height: 100vh;
    }

    .fixed-header {
      position: fixed;
      top: 0;
      left: 260px; /* 240px sidebar + 20px gap */
      right: 0;
      width: auto;
      z-index: 1000;
    }

    .content-area {
      margin-top: 64px; /* header height */
      padding: 2rem;
      height: calc(100vh - 64px);
      overflow-y: auto;
    }
  `
})
export class NgoLayoutComponent {}
